<div class="ipd-data" [attr.dark-theme]="isDark ? 'true' : 'false'" *ngIf="render">
  <div class="ipd-header">
    <h2>Insect Detection Dashboard</h2>

    <div class="controls">
      <div class="control-group" (click)="startTimeInput.showPicker()">
        <label for="start-time">From</label>
        <input type="datetime-local" [value]="startDateTime" [max]="endDateTime" (input)="onInput($event, 'startDateTime')" #startTimeInput>
      </div>
      <div class="control-group" (click)="endTimeInput.showPicker()">
        <label for="end-time">To</label>
        <input type="datetime-local" [value]="endDateTime" [min]="startDateTime" (input)="onInput($event, 'endDateTime')" #endTimeInput>
      </div>
    </div>
  </div>

  <div class="chart-container">
    <canvas baseChart [datasets]="chartData" [labels]="chartLabels" [options]="chartOptions" [legend]="chartLegend" [chartType]="chartType" #ipdChart="base-chart"></canvas>
  </div>

  <div class="control-group center">
    <input type="checkbox" id="filter-zero" [(ngModel)]="hideZeros" (change)="onInput($event, 'hideZeros')" #hideZeroInput>
    <label for="filter-zero">Hide Records With Zero Activations</label>
  </div>

  <div class="table-container" id="tableWrapper">
    <table>
      <thead>
        <tr>
          <th>Period Start</th>
          <th>Period End</th>
          <th>Activation Range</th>
        </tr>
      </thead>
      <tbody id="tableBody">
        <tr *ngIf="!records?.length">
          <td colspan="3" style="text-align:center;">No data found for this range.</td>
        </tr>
        <tr *ngFor="let r of records; let i = index" [id]="'table-row-' + i" (mouseenter)="rowEnter($event)" (mouseleave)="rowLeave($event)">
          <td>{{formatDate(r.period_start)}}</td>
          <td>{{formatDate(r.period_end)}}</td>
          <td>{{formatRangeText(r)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>